export enum ChangeRequestStatus {
    Pending = 'pending',
    Cancelled = 'cancelled',
    Complete = 'complete',
    Approved = 'approved',
    Denied = 'denied',
}
